import * as React from 'react';
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';
import isLength from 'validator/lib/isLength';
import equals from 'validator/lib/equals';

const config = require("../../../constants/constants.js")

const EditCustomerPageComponent = ({ updateCustomerApiRequest, fetchCustomer }) => {

  const [validated, setValidated] = useState(false);
  const [customer1, setCustomer1] = useState([]);
  const [updateCustomerResponseState, setUpdateCustomerResponseState] = useState({ message: "", error: "" });

  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [telephone, setTelephone] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [via, setVia] = useState("");
  const [cap, setCap] = useState("");
  const [citta, setCitta] = useState("");
  const [provincia, setProvincia] = useState("");
  const [piva, setPiva] = useState("");
  const [codicefiscale, setCodicefiscale] = useState("");
  const [image, setImage] = useState("");
  const [shippingAddress, setShippingAddress] = useState([]);


  useEffect(() => {
    fetchCustomer(id)
      .then(data => {
        console.log(`data =`, data);
        setTitle(data?.title);
        setName(data?.name);
        setSurname(data?.surname);
        setTelephone(data?.telephone);
        setMobile(data?.mobile);
        setEmail(data?.email);
        setVia(data?.via);
        setCap(data?.cap);
        setCitta(data?.citta);
        setProvincia(data?.provincia);
        setPiva(data?.piva);
        setCodicefiscale(data?.codicefiscale);
        setShippingAddress(data?.shippingAddress);
        console.log(`name  =`, name);
        console.log(`surname  =`, surname);
        console.log(`provincia  =`, provincia);
        console.log(`shippingAddress  =`, shippingAddress);

      })
      .catch((er) => console.log(er.response.data.message ? er.response.data.message : er.response.data));
  }, [id])

  function salvaCustomerModificato(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();

    console.log(`title dig =`, title);
    console.log(`name dig =`, name);
    console.log(`surname dig =`, surname);
    console.log(`telephone dig =`, telephone);
    console.log(`mobile dig =`, mobile);
    console.log(`email dig =`, email);
    console.log(`via dig =`, via);
    console.log(`cap dig =`, cap);
    console.log(`citta dig =`, citta);
    console.log(`provincia dig =`, provincia);
    console.log(`piva dig =`, piva);
    console.log(`codicefiscale dig =`, codicefiscale);

    updateCustomerApiRequest(id, title, name, surname, telephone, mobile, email, via, cap, citta, provincia, piva, codicefiscale, image)
      .then(data => {
        if (data.success === "customer updated") {
          navigate("/admin/customers");
        }
      })
      .catch(er => {
        setUpdateCustomerResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data });
      })

    window.location.assign('/admin/customers')
  }

  function gotoIndietro(eventKey) {
    eventKey.preventDefault();
    eventKey.stopPropagation();
    window.location.assign('/admin/customers')
  }

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/customers">
              {config.BC_ADMIN_CUSTOMERS}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_CUSTOMERS_EDIT}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Modifica cliente</b>&nbsp;
            </Typography>

          </Stack>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 20
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6'
            }}
            elevation={6}
          >

            <Stack
              useFlexGap
              sx={{
                flexDirection: { xs: "column", md: "row" },
                paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                flexWrap: 'wrap'
              }}
            >

              <TextField id="id-cliente" label="Cliente" variant="outlined" value={title} defaultValue={title}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setTitle(event.target.value);
                }}
              />

              <TextField id="id-name" label="Nome" variant="outlined" value={name} defaultValue={name}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setName(event.target.value);
                }}
              />

              <TextField id="id-surname" label="Cognome" variant="outlined" value={surname} defaultValue={surname}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setSurname(event.target.value);
                }}
              />

              <TextField id="id-telephone" label="Telefono" variant="outlined" value={telephone} defaultValue={telephone}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setTelephone(event.target.value);
                }}
              />

              <TextField id="id-mobile" label="Mobile" variant="outlined" value={mobile} defaultValue={mobile}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setMobile(event.target.value);
                }}
              />

              <TextField id="id-email" label="Email" variant="outlined" value={email} defaultValue={email}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
              />

              <TextField id="id-via" label="Via" variant="outlined" value={via} defaultValue={via}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setVia(event.target.value);
                }}
              />

              <TextField id="id-cap" label="CAP" variant="outlined" value={cap} defaultValue={cap}
                sx={{
                  width: "15ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCap(event.target.value);
                }}
              />

              <TextField id="id-citta" label="Città" variant="outlined" value={citta} defaultValue={citta}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCitta(event.target.value);
                }}
              />

              <TextField id="id-provincia" label="Provincia" variant="outlined" value={provincia} defaultValue={provincia}
                sx={{
                  width: "20ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setProvincia(event.target.value);
                }}
              />

              <TextField id="id-piva" label="Partita iva" variant="outlined" value={piva} defaultValue={piva}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setPiva(event.target.value);
                }}
              />

              <TextField id="id-codicefiscale" label="Codice fiscale" variant="outlined" value={codicefiscale} defaultValue={codicefiscale}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCodicefiscale(event.target.value);
                }}
              />


              <TextField id="id-name" label="Cognome e nome" variant="outlined" value={name} defaultValue={name}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setName(event.target.value);
                }}
              />

              <TextField id="id-address" label="Indirizzo" variant="outlined" value={via} defaultValue={via}
                sx={{
                  width: "35ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setVia(event.target.value);
                }}
              />

              <TextField id="id-zipCode" label="Cap" variant="outlined" value={cap} defaultValue={cap}
                sx={{
                  width: "15ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCap(event.target.value);
                }}
              />

              <TextField id="id-city" label="Città" variant="outlined" value={citta} defaultValue={citta}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setCitta(event.target.value);
                }}
              />
              <TextField id="id-country" label="Provincia" variant="outlined" value={provincia} defaultValue={provincia}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setProvincia(event.target.value);
                }}
              />

              <TextField id="id-telephone" label="Telefono" variant="outlined" value={telephone} defaultValue={telephone}
                sx={{
                  width: "25ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                onChange={(event) => {
                  setTelephone(event.target.value);
                }}
              />


            </Stack>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: "row", md: "row" },
                alignItems: "center",
                justifyContent: "center"
              }}
            >

              <Button
                type="button"
                variant="contained"
                color="warning"
                onClick={(e) => { gotoIndietro(e); }}
                sx={{
                  width: "12ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >
                Indietro
              </Button>


              <Button
                type="button"
                variant="contained"
                color="success"
                onClick={(e) => { salvaCustomerModificato(e); }}
                sx={{
                  width: "12ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >
                Salva
              </Button>

            </Box>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 20
              }}
            />

          </Paper>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

        </Box>

      </Grid>

    </Box>

  );
};

export default EditCustomerPageComponent;
